<script>
import Carousel from "../custom/carousel.vue";
import { TicketsIndex } from "../../app/consumer/controllers/tickets.index";


export default {
    name: "AdCarousel",
    components: { Carousel },
    mixins: [TicketsIndex],
    data: () => ({
        car: 0,
        ads: [
            { id: "zesa", img: "/images/ads/6.jpg", link: "/zesa" },
            { id: "book-demo", img: "/images/ads/1.jpg", link: "/business/book-demo" },
            { id: "home", img: "/images/ads/2.jpg", link: "/" },
            { id: "zesa-calculator", img: "/images/ads/7.jpg", link: "/calculators/zesa-calculator" },
            { id: "telone", img: "/images/ads/4.jpg", link: "/telone/usd" },
            { id: "zesa-2", img: "/images/ads/5.jpg", link: "/zesa" },
        ],
        allSlides: [],
    }),
    computed: {
        paidEvents() {
            const today = new Date().toISOString().split('T')[0];
            return this.tickets.content.data
                .filter(event => event.event_type === "PAID" && event.event_at >= today)
                .map(event => ({
                    id: `event-${event.id}`,
                    img: event.image,
                    link: `/tickets/buy/${this.encode(event.id)}/${event.name.toLowerCase().replace(/ /g, '-')}`
                }));
        }
    },
    async mounted() {
        await this.getTicketEvents();
        this.allSlides = [...this.paidEvents, ...this.ads];

        this.$nextTick(() => {
            this.startCarousel();
        });
    },
    methods: {
        startCarousel() {
            const cycle = () => {
                setTimeout(() => {
                    this.car = (this.car + 1) % this.allSlides.length;
                    cycle();
                }, 7000);
            };
            cycle();
        }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    }
};
</script>

<template>
    <transition-group tag="div" class="overflow-hidden hidden" name="slide-in-left">
        <div v-for="(slide, index) in allSlides" :key="slide.id" v-if="car === index">
            <router-link :to="slide.link" target="_blank">
                <img class="rounded-lg w-100" :src="slide.img" alt="">
            </router-link>
        </div>
    </transition-group>
</template>

<style scoped>
@media (max-width: 992px) {
    .hidden {
        display: none;
    }
}
</style>
